import { $el, $qs, $replaceWith } from 'fxdom/es';
import { go } from 'fxjs/es';
import { OMPCoreLayoutTmplS } from '../../S/Tmpl/module/OMPCoreLayoutTmplS.js';

export const resetLeftSubMenu = (is_login) => {
  const left_sub_menu = $qs('.omp-left__menu2');
  if (!left_sub_menu) return;
  go(left_sub_menu, $replaceWith($el(OMPCoreLayoutTmplS.ompLeftSubMenu({ selected_menu: null, is_login }))));
};
